import * as jQuery from 'jquery';
import { forkJoin, Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { Configuration } from '../../../analytics-core/interfaces/configuration.interface';
import { ConfigurationLoaderService } from '../../../analytics-core/services/configuration-loader.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';

@Component({
	selector: 'app-navigation',
	styleUrls: ['../styles/navigation.component.css'],
	templateUrl: '../views/navigation.component.html'
})
export class NavigationComponent implements OnInit, AfterViewInit {
	public configuration: Configuration;
	public content: string;

	public isMenuActive = false;

	constructor(
		private http: HttpClient,
		private analyticsDataModel: AnalyticsDataModel,
		private configurationLoader: ConfigurationLoaderService
	) {
		EmitterService.get(EVENT_EMITTERS.TOGGLE_LAYOUT).subscribe((response: any) => {
			jQuery('#left-menu').removeClass('active');
			jQuery('#left-menu').addClass('inactive');
		});
	}

	ngOnInit(): void {
		this.configuration = this.analyticsDataModel.config;
		this.analyticsDataModel.overViewReportDetails = [];
	}

	ngAfterViewInit(): void {
		this.analyticsDataModel.overViewReportDetails = [];
		const url = `assets/partner-assets/${this.getDirectoryName()}/views/navigation.html`;
		const breadcrumb = this.http.get(url, { responseType: 'text' });
		forkJoin([breadcrumb]).subscribe(
			(responses: any[]) => {
				let html = '';
				for (const resp of responses) {
					html += resp;
				}
				this.content = this.configurationLoader.generateHTMLForNavigationWidgets(
					this.configuration.navWidgets,
					html,
					this.configuration.isNavigationCarousel
				);
			},
			(err) => console.error(err)
		);
	}

	getDirectoryName(): string {
		if (this.configuration.useDefaultHtmls) {
			return `default-${this.configuration.version.toLowerCase()}`;
		}
		return this.configuration.partner.directoryName;
	}
}
